import { combineReducers } from 'redux';
import { listData } from './list';
import { toastData } from './toast';

import indexNew from './indexNew';

const newsApp = combineReducers({

    listData,
    toastData,
    ...indexNew
});

export default newsApp;
